<template>
<div class="chapter">
<div class="inner_page">
<p class="txt1"> </p>
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Editor: Lynn Koolish</p>
<p class="copy">Technical Editor: Teresa Stroin</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Production Editor: Alice Mace Nakanishi</p>
<p class="copy">Photo Assistant: Carly Jean Marin</p>
<p class="copy">Photography by Diane Pedersen, unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?27fc784a